import { ShowOrganizationResponseSchema } from './show-organization.schema';
/**
 * Show Organization Endpoint Contract
 * Retrieves the current organization details
 */ export const showOrganizationContract = {
    method: 'GET',
    path: '/api/v2/organization',
    description: "Retrieve the authenticated user's organization details",
    responseSchema: ShowOrganizationResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=show-organization.contract.js.map